/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type EditPermissionSchemePageType from '@jira/permissions-administration__pages-edit-permission-scheme/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyEditPermissionSchemePage: LazyComponent<
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<any, any>) => React.JSX.Element
> = lazyForPaint<typeof EditPermissionSchemePageType>(() =>
	markAsProductBundleReady(
		// eslint-disable-next-line jira/import/file-extension-required
		import(
			/* webpackChunkName: "async-jira-edit-permission-scheme", jiraSpaEntry: "async-jira-edit-permission-scheme" */ '@jira/permissions-administration__pages-edit-permission-scheme'
		),
	),
);

const AsyncEditPermissionSchemePage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyEditPermissionSchemePage}
		pageId="jira-edit-permission-scheme"
		shouldShowSpinner
	/>
);

export default AsyncEditPermissionSchemePage;
